import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

// Secção de um formulário/step: badge circular colorido + título, com o conteúdo dentro de
// um cartão com borda. Usado em todos os ecrãs de Cadastro/Renovação de estudante para dar
// consistência visual. `accent` escolhe a cor do badge/borda entre as que já existem no
// design system (primary/success/info/warning/danger).
const StepCard = ({ icon, title, subtitle, accent = "primary", children }) => (
  <div className={`p-20 radius-16 border border-${accent}-100 mb-24`}>
    <div className={`d-flex align-items-center gap-12 ${subtitle ? "mb-4" : "mb-20"}`}>
      <span
        className={`w-40-px h-40-px rounded-circle bg-${accent}-50 text-${accent}-600 d-flex align-items-center justify-content-center flex-shrink-0`}
      >
        <Icon icon={icon} className='text-xl' />
      </span>
      <h6 className='text-md mb-0'>{title}</h6>
    </div>
    {subtitle && (
      <p className='text-secondary-light text-sm mb-20' style={{ paddingLeft: 52 }}>
        {subtitle}
      </p>
    )}
    {children}
  </div>
);

export default StepCard;
